




import Contact from "@/models/contact";
import { LayoutModule } from "@/store/layout";
import { Component, Vue } from "vue-property-decorator";
import ContactForm from "./Components/ContactForm.vue";
import ContactAPI from "@/services/contacts";

@Component({
  components: { ContactForm },
})
export default class NewContact extends Vue {
  async save(contact: Contact): Promise<void> {
    LayoutModule.showLoader();
    LayoutModule.setAlerts([]);
    try {
      await ContactAPI.newContact(contact);
      LayoutModule.setAlerts({
        text: this.$t("contacts.responses.success_create").toString(),
        type: "success",
      });
    } catch (e) {
      console.log(e);
    }
    LayoutModule.hideLoader();
  }

  cancel(): void {
    this.$router.push({ name: "contacts" });
  }
}
